define('productDescriptionTabs/replacementParts',[
],
function () {

    function init() {
        $(".more-replacement-parts .link").off("click").on("click", showMoreReplacementParts);
        if ($(".replacement-parts .part-tile").length > partsInitiallyDisplayedOnMobile) {
            $(window).off("resize.replacementParts").on("resize.replacementParts", adjustNumberofDisplayedParts);
        }
        showMoreLinkVisible = true;
        currentView = views.none;
        adjustNumberofDisplayedParts();
    }

    function showMoreReplacementParts(event) {
        $(".replacement-parts .part-tile").removeClass("d-none");
        $(".more-replacement-parts").addClass("d-none");
        showMoreLinkVisible = false;
    }

    var views = {
        desktop: 1,
        mobile: 2,
        none: 3
    };

    var partsInitiallyDisplayedOnMobile = 2;
    var partsInitiallyDisplayedOnDesktop = 3;
    var showMoreLinkVisible = true;

    var currentView = views.none;
    var mobileBreakpoint;

    function adjustNumberofDisplayedParts(event) {
        if (!showMoreLinkVisible) return;

        var width = $(window).width();
        if (!mobileBreakpoint) {
            mobileBreakpoint = $(".dynamic-mobile-accordion").data("mobileBreakpoint");
        }

        if (width < mobileBreakpoint && currentView !== views.mobile) {
            // SWITCH TO MOBILE
            $(".replacement-parts .part-tile.active").addClass("d-none");
            $(".replacement-parts .part-tile.active:lt(" + partsInitiallyDisplayedOnMobile + ")").removeClass("d-none");

            if ($(".replacement-parts .part-tile.active").length > partsInitiallyDisplayedOnMobile) {
                $(".more-replacement-parts").removeClass("d-none");
            } else {
                $(".more-replacement-parts").addClass("d-none");
            }

            currentView = views.mobile;
        } else if (width >= mobileBreakpoint && currentView !== views.desktop) {
            // SWITCH TO DESKTOP
            $(".replacement-parts .part-tile.active").addClass("d-none");
            $(".replacement-parts .part-tile.active:lt(" + partsInitiallyDisplayedOnDesktop + ")").removeClass("d-none");

            if ($(".replacement-parts .part-tile.active").length > partsInitiallyDisplayedOnDesktop) {
                $(".more-replacement-parts").removeClass("d-none");
            } else {
                $(".more-replacement-parts").addClass("d-none");
            }

            currentView = views.desktop;
        }

        var activePartsCount = $(".replacement-parts .part-tile.active").length;
        if (activePartsCount > 0) {
            $(".more-replacement-parts .count").text(activePartsCount);
            $(".replacement-parts").removeClass("d-none");
        }
        else {
            $(".replacement-parts").addClass("d-none");
        }
        
    }

    function display(variantSku) {
        $(".replacement-parts .part-tile[data-related-to-variant-sku!='']").removeClass("active");
        $(".replacement-parts .part-tile[data-related-to-variant-sku='" + variantSku + "']").addClass("active");
        init();
    }

    return {
        display: display
    };
    
});

